import { render, staticRenderFns } from "./StatusWidget.vue?vue&type=template&id=53e3bee2&scoped=true&"
import script from "./StatusWidget.vue?vue&type=script&lang=ts&"
export * from "./StatusWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3bee2",
  null
  
)

export default component.exports